import { sortBy } from 'lodash';
import config from '~/config';
import http from './http';

export const getOrderContactsByFirm = async (firmName) => {
    try {
        const url = `${config.urls.base}/orderContact/${firmName}`;
        const response = await http.get2(url);

        if (response.errored) {
            throw new Error(response.error);
        }
        
        return sortBy(response, ['firstName']);

    } catch (err) {
        console.error(err);
        return null;
    }
};

export default {
    getOrderContactsByFirm
};